<template>
  <div class="inputDevice">
    <div class="ticket-item" v-for="(item, index) in controllerNumber" :key="item.metaTicketInfo.productId" v-if="item.orderItemAttr.length">
      <ul>
        <li :ref="`DOM${item.metaTicketInfo.ticketKindSn}${index1}`" v-for="(item1, index1) in item.orderItemAttr" :key="index1">
          <h1 class="ticket-name" v-if="index1 === 0">
            <span>{{ item.metaTicketInfo.englishName }}</span>
          </h1>
          <h1>
            <span>Visitor {{ index1 + 1 }}</span>
            <i v-if="surplusLength > 1" @click="deleteControllerNumber(item, index1)">Delete</i>
          </h1>
          <div class="inpot-box" v-if="item.metaTicketInfo.needTravellerName == 'true'">
            <label :for="`name${item.metaTicketInfo.ticketKindSn}${item.metaTicketInfo.productId}${index1}`" style="white-space:pre-wrap;line-height: 0.666667rem;">Name</label>
            <input
              @input="changeControllerNumber"
              type="text"
              maxlength="50"
              v-model.trim="item1.traverllerName"
              :id="`name${item.metaTicketInfo.ticketKindSn}${item.metaTicketInfo.productId}${index1}`"
              placeholder="Fill your name here">
          </div>
          <div class="inpot-box" v-if="item.metaTicketInfo.needTravellerMobile == 'true'">
            <label :for="`contactTelephone${item.metaTicketInfo.ticketKindSn}${item.metaTicketInfo.productId}${index1}`">Phone</label>
            <input
              @input="changeControllerNumber"
              v-model.trim="item1.traverllerPhone"
              type="tel"
              v-mobile
              maxlength="11"
              :id="`contactTelephone${item.metaTicketInfo.ticketKindSn}${item.metaTicketInfo.productId}${index1}`"
              placeholder="Fill your Phone number here">
          </div>
          <div class="inpot-box" v-if="item.metaTicketInfo.needTravellerEmail == 'true'">
            <label :for="`email${item.metaTicketInfo.ticketKindSn}${item.metaTicketInfo.productId}${index1}`">Email</label>
            <input @input="changeControllerNumber" v-model.trim="item1.traverllerEmail" maxlength="50" type="email" :id="`email${item.metaTicketInfo.ticketKindSn}${item.metaTicketInfo.productId}${index1}`" placeholder="Fill your Email here">
          </div>
          <div
            class="inpot-box"
            v-if="!(item.metaTicketInfo.needTravellerIDCard == 'false'
            && item.metaTicketInfo.needTravellerPassport == 'false'
            && item.metaTicketInfo.needTravellerPRC == 'false'
            && item.metaTicketInfo.needTravellerHKMTPassport == 'false')">
            <label for="" style="white-space:pre-wrap;line-height: 0.666667rem;">ID Type</label>
            <ul class="type-list">
              <li class="flow hmt">
                <div
                  class="common-item"
                  v-if="item.metaTicketInfo.needTravellerIDCard == 'true'"
                  :class="{ 'currentIndex': item1.traverllerCerType === 'id_card' }"
                  @click="changeCardType(item1, 'id_card')">
                  <span>ID Card </span>
                  <img src="~@/assets/image/common/common_select.png" alt="">
                </div>
                <div
                  class="common-item"
                  v-if="item.metaTicketInfo.needTravellerPassport == 'true'"
                  @click="changeCardType(item1, 'passport')"
                  :class="{ 'currentIndex': item1.traverllerCerType === 'passport' }">
                  <span>Passport</span>
                  <img src="~@/assets/image/common/common_select.png" alt="">
                </div>
                <div
                  class="common-item"
                  v-if="item.metaTicketInfo.needTravellerHKMTPassport == 'true'"
                  :class="{ 'currentIndex': item1.traverllerCerType === 'hkmo_id_card' }"
                  @click="changeCardType(item1, 'hkmo_id_card')">
                  <div class="text">HK, Macao,Taiwan</div>
                  <div class="text">exit-entry permit</div>
                  <img src="~@/assets/image/common/common_select.png" alt="">
                </div>
                <div
                  :class="{
                    'currentIndex':  item1.traverllerCerType === 'prc',
                    'special': $checkFullNumber(item.metaTicketInfo, 'traveller') === 4,
                    'endControlPosition': item.needTravellerHKMTPassport == 'true' &&
                                          item.needTravellerIDCard == 'true' &&
                                          item.needTravellerPRC == 'true' &&
                                          item.needTravellerPassport == 'true'
                    }"
                  v-if="item.metaTicketInfo.needTravellerPRC == 'true'"
                  @click="changeCardType(item1, 'prc')"
                  class="common-item">
                  <!-- <div class="text">外国人永久</div> -->
                  <div class="text">PR</div>
                  <img src="~@/assets/image/common/common_select.png" alt="">
                </div>
                <template v-if="$checkFullNumber(item.metaTicketInfo, 'traveller') > 3">
                  <div
                    v-for="index in $checkFullNumber(item.metaTicketInfo, 'traveller')"
                    :key="index"
                    class="common-item hide"></div>
                </template>
              </li>
            </ul>
          </div>
          <div
            class="inpot-box"
            v-if="!(item.metaTicketInfo.needTravellerIDCard === 'false'
            && item.metaTicketInfo.needTravellerPassport === 'false'
            && item.metaTicketInfo.needTravellerPRC === 'false'
            && item.metaTicketInfo.needTravellerHKMTPassport == 'false')">
            <label :for="`certificateNo${item.metaTicketInfo.ticketKindSn}${item.metaTicketInfo.productId}${index1}`" style="white-space:pre-wrap;line-height: 0.666667rem;">ID number</label>
            <input
              @input="changeControllerNumber"
              v-model.trim="item1.traverllerCerNo"
              :maxlength="maxLengList[`${item1.traverllerCerType}`]"
              type="text"
              :id="`certificateNo${item.metaTicketInfo.ticketKindSn}${item.metaTicketInfo.productId}${index1}`"
              placeholder="Fill your ID number here">
          </div>
          <template v-if="item.metaTicketInfo.needPolicyCertificates == 'true' && item.metaTicketInfo.policyList">
            <div class="inpot-box">
              <label for="">Other documents</label>
              <ul class="type-list">
                <li class="flow">
                  <div
                    class="common-item"
                    v-for="item2 in item.metaTicketInfo.policyList"
                    :key="item2.cerType"
                    :class="{ 'currentIndex': item1.traverllerFreeCerType === item2.cerType }"
                    @click="changeFreeCardType(item1, item2.cerType)">
                    <span>{{ item2.cerTypeName }}</span>
                    <img src="~@/assets/image/common/common_select.png" alt="">
                  </div>
                  <template v-if="item.metaTicketInfo.policyList.length > 3">
                    <div
                      v-for="index in 3 - item.metaTicketInfo.policyList.length"
                      :key="index"
                      class="common-item hide"></div>
                  </template>
                </li>
              </ul>
            </div>
            <div class="inpot-box">
              <label :for="`traverllerFreeCerNo${item.metaTicketInfo.ticketKindSn}${item.metaTicketInfo.productId}${index1}`">证件号</label>
              <input
                @input="changeControllerNumber"
                v-model.trim="item1.traverllerFreeCerNo"
                type="text"
                :id="`traverllerFreeCerNo${item.metaTicketInfo.ticketKindSn}${item.metaTicketInfo.productId}${index1}`"
                placeholder="Please enter your free ID number">
            </div>
            <div class="inpot-box">
              <label :for="`traverllerUpload${item.metaTicketInfo.ticketKindSn}${item.metaTicketInfo.productId}${index1}`">证件上传</label>
              <input
                style="display: none"
                type="file"
                accept="image/*"
                @change="changeImage($event, item1)"
                ref="avatarInput"
                :id="`traverllerUpload${item.metaTicketInfo.ticketKindSn}${item.metaTicketInfo.productId}${index1}`"
              />
              <label v-if="item1.imageState" class="uploadOccupy" :for="`traverllerUpload${item.metaTicketInfo.ticketKindSn}${item.metaTicketInfo.productId}${index1}`">
                <img ref="DOMShowImage" src="@/assets/image/common/common_fill.png" alt="">
              </label>
              <!-- <img @click="displayImageDetails" v-else :src="item1.imageUrl" alt=""> -->
              <div v-else class="certificatesPhotoBox">
                <img :src="item1.imageLocalUrl" alt="">
                <img  @click="displayImageDetails(item1)" class="icon" src="~@/assets/image/buyTickets/buyTickets_delete.png" alt="">
              </div>
            </div>
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getupload } from '@/service/register';
export default {
  name: "inputDevice",
  props: {
    controllerNumber: {
      type: Array,
      default: () => [],
    },
    selectDate: {
      type: Object
    },
  },
  data() {
    return {
      _controllerNumber: [],
      surplusLength: 0,
      maxLengList: {
        'id_card': process.env.VUE_APP_IDCARD_MAX_LENGTH,
        'passport': process.env.VUE_APP_PASSPORT_MAX_LENGTH,
        'hkmo_id_card': process.env.VUE_APP_HKMO_IDCARD_MAX_LENGTH,
        'prc': process.env.VUE_APP_PRC_MAX_LENGTH,
      },
    }
  },
  methods: {
    deleteControllerNumber(item, index){
      item.count --;
      this.$emit('updataControllerNumber', {
        type: 'delete',
        data: this._controllerNumber,
        currentItem: item.orderItemAttr[index],
      });
      item.orderItemAttr.splice(index, 1);
      this.$forceUpdate();
    },
    changeControllerNumber(e, type){
      this.$emit('updataControllerNumber', {
        type: 'updata',
        data: this._controllerNumber,
      });
    },
    async changeImage(event, item){
      // 上传图片事件
      let file = event.target.files[0];
      const MAXMB = 2;
      const isLtSize = file.size / 1024 / 1024 < MAXMB;
      if(!isLtSize)return this.$toast(`上传图片大小不能超过 ${MAXMB}MB!`);
      let param = new FormData();
      param.append("file", file);
      item.imageLocalUrl = await this.$getBase64(file);
      const { data } = await getupload.call(this, param);
      if(data){
        item.imageServerUrl = data;
        item.imageState = false;
      };
      this.$forceUpdate();
    },
    changeCardType(target, traverllerCerType){
      target.traverllerCerType = traverllerCerType;
      this.$forceUpdate();
    },
    changeFreeCardType(target, traverllerFreeCerType){
      target.traverllerFreeCerType = traverllerFreeCerType;
      this.$forceUpdate();
    },
    checkControllerNumber(){
      const selectDate = this.selectDate;
      let failText = '';
      const auxiliaryAction = (metaTicketInfo, i, errorText, typeName) => {
        const { ticketKindSn, productId } = metaTicketInfo
        failText = errorText;
        const currentDOM = this.$refs[`DOM${ticketKindSn}${i}`][0];
        const { offsetTop } = currentDOM;
        const DOMInputId = `${typeName}${ticketKindSn}${productId}${i}`;
        document.getElementById(DOMInputId).focus();
        document.documentElement.scroll({ top: offsetTop, behavior: 'smooth' });
        return true;
      };
      this._controllerNumber.find(item => {
        const { metaTicketInfo } = item;
        return item.orderItemAttr.find((v, i) => {
          if(metaTicketInfo.needTravellerName === "true" && !v.traverllerName){
            return auxiliaryAction(metaTicketInfo, i, `${item.metaTicketInfo.englishName}Tourist${i + 1} Name not filled in`, 'name');
          };

          if(metaTicketInfo.needTravellerName === "true" && !this.$reg.checkName.test(v.traverllerName)){
            return auxiliaryAction(metaTicketInfo, i, `${item.metaTicketInfo.englishName}Tourist${i + 1} Please do not fill in special characters in your name`, 'name');
          };

          if(!(metaTicketInfo.needTravellerIDCard === "false" && metaTicketInfo.needTravellerHKMTPassport === "false" && metaTicketInfo.needTravellerPassport === "false") && !v.traverllerCerNo){
            return auxiliaryAction(metaTicketInfo, i, `${item.metaTicketInfo.englishName}Tourist${i + 1} ID number not filled in`, 'certificateNo');
          };

          if(metaTicketInfo.needTravellerMobile === "true" && !v.traverllerPhone && this.$reg.checkPhone(v.traverllerPhone)){
            return auxiliaryAction(metaTicketInfo, i, `${item.metaTicketInfo.englishName}Tourist${i + 1} No phone input or incorrect phone format`, 'contactTelephone');
          };

          if(v.traverllerCerType == 'id_card' && metaTicketInfo.needTravellerIDCard === "true" && !this.$reg.checkIDCard(v.traverllerCerNo)){
            return auxiliaryAction(metaTicketInfo, i, `${item.metaTicketInfo.englishName}Tourist${i + 1} Incorrect format of ID card`, 'certificateNo');
          };

          if(v.traverllerCerType === "passport" && !this.$reg.checkPassportNo.test(v.traverllerCerNo)){
            return auxiliaryAction(metaTicketInfo, i, `${item.metaTicketInfo.englishName}Tourist${i + 1} Please enter the correct identification number`, 'certificateNo');
          }

          if(v.traverllerCerType === "hkmo_id_card" && !this.$reg.checkhkmTPassportNo.test(v.traverllerCerNo)){
            return auxiliaryAction(metaTicketInfo, i, `${item.metaTicketInfo.englishName}Tourist${i + 1} Please enter the correct identification number`, 'certificateNo');
          };

          if(v.traverllerCerType === "prc" && !this.$reg.checkNewPrcNo(v.traverllerCerNo)){
            return auxiliaryAction(metaTicketInfo, i, `${item.metaTicketInfo.englishName}Tourist${i + 1} Please enter the correct identification number`, 'certificateNo');
          };

          if(metaTicketInfo.saleAgeInfos.length && this.$reg.checkIDCard(v.traverllerCerNo)){
            const checkAge = this.$reg.checkAge(v.traverllerCerNo, selectDate.saleDate);
            let errorInfo = '';
            const ckeckAllAge = metaTicketInfo.saleAgeInfos.every(({ travellerMaxAge, travellerMinAge }) => {
              const SALE_TYPE = metaTicketInfo.attrInfos.find(v => v.friendlyName == 'SALE_TYPE').key;
              // 只有是身份证的时候才校验年龄
              if(metaTicketInfo.needTravellerIDCard === "true"){
                if(SALE_TYPE != 'free'){
                  if(checkAge < 18 || checkAge > 59){
                    errorInfo = `${item.metaTicketInfo.englishName}Tourist${i + 1} Under 18 years old and over 60 years old do not require ticket purchase`;
                    return true;
                  };
                };
                // 优惠票 年龄超过25岁的特殊提示
                if(metaTicketInfo.saleType === 'discount' && checkAge > travellerMaxAge) {
                  errorInfo = `${item.metaTicketInfo.englishName}Tourist${i + 1} Not eligible for automatic age recognition. Please bring your discounted documents to the manual window to purchase tickets`;
                  return true
                }
                if (SALE_TYPE == 'free' && checkAge < travellerMinAge || checkAge > travellerMaxAge){
                  errorInfo = `${item.metaTicketInfo.englishName}Tourist${i + 1} Age does not match the type of ticket purchased`;
                  return true;
                }else if(SALE_TYPE != 'free' && checkAge < travellerMinAge || checkAge > travellerMaxAge){
                  errorInfo = `${item.metaTicketInfo.englishName}Tourist${i + 1} Age does not match the type of ticket purchased`;
                  return true;
                }
              }
            });
            if(ckeckAllAge)return auxiliaryAction(metaTicketInfo, i, errorInfo, 'certificateNo');
          };

          if(v.traverllerFreeCerType && !v.traverllerFreeCerNo){
            return auxiliaryAction(metaTicketInfo, i, `${item.metaTicketInfo.englishName}Tourist${i + 1} Please enter a free ID number`, 'traverllerFreeCerNo');
          }
        });
      });
      // 查重
      const repeatArray = [];
      this._controllerNumber.some(item => {
        const { metaTicketInfo } = item;
        return item.orderItemAttr.some((v, i) => {
          if(!v.traverllerCerNo)return false;
          const traverllerCerNo = this.$reg.checkIDCard(v.traverllerCerNo) ? v.traverllerCerNo.toLocaleLowerCase() : v.traverllerCerNo;
          if(!repeatArray.includes(traverllerCerNo)){
            repeatArray.push(traverllerCerNo);
            return false;
          }else{
            return auxiliaryAction(metaTicketInfo, i, `${item.metaTicketInfo.englishName}Tourist${i + 1} The ID number is duplicated`, 'certificateNo');
          };
        });
      });
      return failText;
    },
    displayImageDetails(item){
      delete item.imageLocalUrl;
      delete item.imageServerUrl;
      item.imageState = true;
      this.$forceUpdate();
    },
  },
  watch: {
    controllerNumber: {
      handler(newValue){
        newValue.forEach(v => {
          if(!v.orderItemAttr)return;
          v.orderItemAttr.reduce((pre, cur, i, arr) => {
            if(pre.includes(cur.traverllerCerNo)){
              cur.traverllerCerNo = "";
              cur.traverllerEmail = "";
              cur.traverllerName = "";
              cur.traverllerPhone = "";
              cur.imageState = true;
            }else if(cur.traverllerCerNo){
              pre.push(cur.traverllerCerNo);
            };
            return pre;
          }, []);
        });
        if(newValue[0].orderItemAttr){
          return this._controllerNumber = newValue
        };
        this._controllerNumber = newValue.map(v => {
          const { metaTicketInfo } = v;
          v.orderItemAttr = [];
          for(let i = 0; i < v.count; i++){
            const structure = {
              traverllerName: '',
              traverllerPhone: '',
              traverllerEmail: '',
              traverllerCerType: metaTicketInfo.needTravellerIDCard === "true" ? 'id_card' : 'passport',
              traverllerCerNo: '',
              imageState: true,
            };
            v.orderItemAttr.push(structure);
          };
          return v;
        });
      },
      immediate: true,
      deep: true,
    },
    _controllerNumber: {
      handler(newValue){
        const surplusLength = newValue.reduce((previous, current) => {
          if(current.orderItemAttr)previous += current.orderItemAttr.length;
          return previous
        }, 0);
        this.surplusLength = surplusLength;
      },
      immediate: true,
      deep: true,
    }
  }
};
</script>

<style scoped lang='less'>
.inputDevice{
  padding:0 .266667rem .6rem;
  background: #FFFFFF;
}
.ticket-item{
  margin-top: 0.133333rem;
  &:first-child{
    margin-top: 0;
  }
  & > ul{
    & > li{
      background: rgba(241, 242, 247, .5);
      border-radius: .173333rem;
      margin-bottom: .133333rem;
      padding-bottom: .4rem;
      &:last-child{
        margin-bottom: 0;
      }
      .ticket-name{
        font-size: .48rem;
        font-weight: bold;
        color: #000000;
        line-height: .666667rem;
      }
      h1{
        font-size: .4rem;
        font-weight: bold;
        color: #000000;
        line-height: .56rem;
        padding: .4rem .4rem 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        i{
          font-size: .373333rem;
          color: #D53A36;
        }
      };
      .inpot-box{
        line-height: 1.44rem;
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgba(241, 242, 247, .5);
        padding: 0 .4rem;
        position: relative;
        font-size: .4rem;
        color: #000000;
        &:last-child{
          border: none;
        }
        label{
          min-width: 4em;
          margin-right: .3rem;
        }
        input{
          flex: 1;
          height: 1.44rem;
        }
        .type-list{
          flex: 1;
          .hmt {
            & > div {
              padding: 0 .1rem !important;
            }
          }
          .flow{
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: space-between;
            .base{
              height: 0.986667rem;
            }

            & > div{
              padding: 0 .4rem;
              &:first-child{
                margin-left: 0;
              };
              .text{
                line-height: .5rem;
                text-align: center;
              }
            };
            .special{
                margin-top: .2rem;
            };
          };


          .common-item{
            background: #FFFFFF;
            box-shadow: 0 .053333rem .106667rem 0 rgba(0,0,0,0.06);
            border-radius: .16rem;
            border: 1px solid #BBBFD3;
            font-size: .373333rem;
            color: #333333;
            line-height: .986667rem;
            position: relative;
            img{
              display: none;
            }
          };
          .hide{
            width: 2em;
            visibility: hidden;
          }

          .currentIndex{
            position: relative;
            background: rgba(59, 109, 156, 0.07);
            border: 1px solid #3B6D9C;
            color: #3B6D9C;
            img{
              height: .346667rem;
              position: absolute;
              display: block;
              right: 0;
              bottom: 0;
            }
          }
        }
        .uploadOccupy{
          width: 1.8667rem;
          height: 1.8667rem;
          border-radius: .16rem;
          border: 1px solid #BBBFD3;
          display: flex;
          align-items: center;
          justify-content: center;
          img{
            width: .5867rem;
            height: .5867rem;
          }
        }
        .certificatesPhotoBox{
          border-radius: .16rem;
          border: 1px solid #BBBFD3;
          position: relative;
          img{
            display: block;
          }
          .icon{
            position: absolute;
            width: .3733rem;
            height: .3733rem;
            right: 0;
            top: 0;
            transform: translate(50%, -50%);
          }
        }
      }
    }
  }
}
</style>

